module.exports = __webpack_public_path__ + "prod/1.42.2/img/distribution-three.d21944c3.png";